import { currencySymbol, currencyWord } from './round-config'
import { el, money, parseMoney } from './ui'

// "How much cash did you take?" in place, on a round with brought money (0043, Astra r2 finding 12): every way of
// marking a visit paid in cash asks, starting on what is due, so cash over is kept as credit and cash under leaves the
// rest owed. One line of fields under the row (the Owed tile's own inline style); Save hands the pence back.
export function askCashTaken(host: HTMLElement, startPence: number, save: (pence: number) => void): void {
  host.querySelector('.cash-ask')?.remove()
  const box = el('div', { class: 'owed-inline cash-ask' })
  const amount = el('input', { type: 'text', inputmode: 'decimal', class: 'owed-inline-amt', 'aria-label': `Cash taken, in ${currencyWord()}` })
  amount.value = (startPence / 100).toFixed(2)
  const err = el('span', { class: 'form-error', role: 'alert' })
  const go = el('button', { type: 'button', class: 'btn-primary' }, 'Save cash')
  const cancel = el('button', { type: 'button' }, 'Cancel')
  cancel.addEventListener('click', () => box.remove())
  go.addEventListener('click', () => {
    let pence: number | null = null
    try {
      pence = parseMoney(amount.value)
    } catch {
      pence = null
    }
    if (pence === null || pence < 0) {
      err.textContent = 'Type what was taken, for example 19 or 19.50 (0 if nothing).'
      return
    }
    go.setAttribute('disabled', 'disabled')
    box.remove()
    save(pence)
  })
  box.append(el('span', { class: 'owed-inline-label' }, `Cash taken (${money(startPence)} due)`), el('span', { class: 'pay-cash-row' }, el('span', { class: 'pay-cash-pound', 'aria-hidden': 'true' }, currencySymbol()), amount), go, cancel, err)
  host.append(box)
  amount.focus()
  amount.select()
}
